/**
 * @file raw.js
 * @author yangwei(yangwei14@baidu.com)
 */

export const html = String.raw;
